import { Disclosure } from "@headlessui/react";
import { MinusSmallIcon, PlusSmallIcon } from "@heroicons/react/24/outline";
import axios from "axios";
import { useEffect, useState } from "react";

const myDate = new Date();

function generateYearsBetween(startYear = 2022, endYear) {
  const endDate = endYear || new Date().getFullYear();
  let years = [];

  for (var i = startYear; i <= endDate; i++) {
    years.push(startYear);
    startYear++;
  }
  return years;
}

const LoadingSpinner = () => (
  // Centralized spinner to be reused
  <div className="flex items-center">
    <svg
      className="animate-spin -ml-1 mr-3 h-5 w-5 text-gray-900"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
    <span>Lädt...</span>
  </div>
);

const yearsArray = generateYearsBetween();

export default function Invoices() {
  const [month, setMonth] = useState(
    myDate.toLocaleString("de-De", { month: "long" }).toLowerCase()
  );
  const [year, setYear] = useState(
    myDate.toLocaleString("de-De", { year: "numeric" })
  );
  const [invoices, setInvoices] = useState([]);
  const [invoiceLoading, setInvoiceLoading] = useState(null);
  const [invoiceSuccess, setInvoiceSuccess] = useState(false);
  const [invoiceAllLoading, setInvoiceAllLoading] = useState(false);
  const [invoiceAllSuccess, setInvoiceAllSuccess] = useState(false);
  const [invoiceDownloading, setInvoiceDownloading] = useState(false);
  const [downloadSuccess, setDownloadSuccess] = useState(false);
  const [response, setResponse] = useState("");

  useEffect(() => {
    try {
      axios
        .get(
          `https://dealersonly.parts/beta/api/admin/getInvoices?year=${year}&month=${month}`
        )
        .then((res) => {
          setInvoices(res.data);
        });
    } catch (error) {
      console.log(error);
    }
  }, [month, year]);

  const printInvoice = (user) => {
    setInvoiceDownloading(true);
    axios
      .post(
        `https://dealersonly.parts/beta/api/admin/downloadInvoice`,
        {
          month: month,
          year: year,
          userEmail: user ? user : "",
        },
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        const fileBlob = new Blob([res.data], { type: "application/pdf" });
        const fileUrl = URL.createObjectURL(fileBlob);

        // Open a new window and write the PDF <object> to it, then print
        const printWindow = window.open();
        printWindow.document.write(
          `<object data="${fileUrl}" type="application/pdf" width="100%" height="100%"></object>`
        );
        printWindow.document.close(); // Necessary for IE >= 10
        printWindow.focus(); // Necessary for IE >= 10

        // Add an event listener to know when the PDF is ready to print
        printWindow.onload = () => {
          printWindow.print();
          URL.revokeObjectURL(fileUrl);
        };

        setInvoiceDownloading(false);
      })
      .catch((error) => {
        console.error(error);
        setInvoiceDownloading(false);
      });
  };

  const downloadInvoice = (user) => {
    setInvoiceDownloading(true);
    try {
      axios
        .post(
          `https://dealersonly.parts/beta/api/admin/downloadInvoice`,
          {
            month: month,
            year: year,
            userEmail: user ? user : "",
          },
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          // setResponse(res.data)

          // Create a URL for the blob
          const fileUrl = window.URL.createObjectURL(new Blob([res.data]));

          // Create a temporary anchor element and trigger the download
          const downloadElement = document.createElement("a");
          downloadElement.href = fileUrl;
          downloadElement.setAttribute(
            "download",
            `rechnung${new Date().toISOString()}.pdf`
          ); // Name the download file appropriately
          document.body.appendChild(downloadElement);
          downloadElement.click();

          // Clean up by revoking the object URL and removing the anchor element
          window.URL.revokeObjectURL(fileUrl);
          document.body.removeChild(downloadElement);

          setDownloadSuccess(true);
          setInvoiceDownloading(false);
          setTimeout(() => {
            setInvoiceSuccess(false);
          }, 2000);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const sendInvoices = (user) => {
    setInvoiceLoading(user[0][0]);
    setInvoiceAllLoading(true);
    try {
      axios
        .post(`https://dealersonly.parts/beta/api/admin/sendInvoices`, {
          month: month,
          year: year,
          userEmail: user ? user : "",
        })
        .then((res) => {
          setResponse(res.data);
          setInvoiceLoading(null);
          setInvoiceSuccess(user[0][0]);
          setInvoiceAllSuccess(true);
          setTimeout(() => {
            setInvoiceSuccess(null);
            setInvoiceAllSuccess(false);
            setInvoiceAllLoading(false);
          }, 2000);
        });
    } catch (error) {
      console.log(error);
    }
  };

  console.log(invoices);

  return (
    <div className="shadow sm:overflow-hidden sm:rounded-md">
      <div className="bg-white py-6 px-4 sm:p-6">
        <div>
          <h2
            id="payment-details-heading"
            className="text-lg font-medium leading-6 text-gray-900"
          >
            Verfügbare Rechnungen
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Eine Übersicht aller Rechnungen für einen gegebenen Monat und Jahr.
          </p>
        </div>
        <div className="mt-6 grid grid-cols-6 gap-6">
          <div className="col-span-6 sm:col-span-3">
            <label
              htmlFor="country"
              className="block text-sm font-medium text-gray-700"
            >
              Abrechnungsmonat
            </label>
            <select
              id="month"
              name="month"
              autoComplete="month"
              className="mt-1 block w-full rounded-md border border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
              defaultValue={month}
              onChange={(e) => setMonth(e.target.value)}
            >
              <option disabled value="">
                Bitte wählen
              </option>
              <option value="januar">Januar</option>
              <option value="februar">Februar</option>
              <option value="märz">März</option>
              <option value="april">April</option>
              <option value="mai">Mai</option>
              <option value="juni">Juni</option>
              <option value="juli">Juli</option>
              <option value="August">August</option>
              <option value="september">September</option>
              <option value="oktober">Oktober</option>
              <option value="november">November</option>
              <option value="dezember">Dezember</option>
            </select>
          </div>
          <div className="col-span-6 sm:col-span-3">
            <label
              htmlFor="country"
              className="block text-sm font-medium text-gray-700"
            >
              Abrechnungsjahr
            </label>
            <select
              id="month"
              name="month"
              autoComplete="month"
              className="mt-1 block w-full rounded-md border border-gray-300 bg-white py-2 px-3 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
              defaultValue={year}
              onChange={(e) => setYear(e.target.value)}
            >
              <option disabled value="">
                Bitte wählen
              </option>
              {yearsArray.map((year) => {
                return <option value={year}>{year}</option>;
              })}
            </select>
          </div>
        </div>
        <div className="mt-6 border-b border-gray-200 pb-5 sm:flex sm:items-center sm:justify-between">
          <div className="sm:w-0 sm:flex-1">
            <h1
              id="message-heading"
              className="text-base font-semibold leading-6 text-gray-900"
            >
              Gesamtstatistik für {month.toUpperCase()} {year}
            </h1>
            <p className="mt-1 truncate text-sm text-gray-500">
              {invoices.data?.userCount} registrierte Benutzer |{" "}
              {invoices.data?.total} in Gebühren
            </p>
          </div>
          <div className="mt-3 sm:mt-0 sm:ml-4">
            <button
              type="button"
              onClick={() => sendInvoices(invoices.data.userArray)}
              className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              {invoiceAllLoading ? (
                <LoadingSpinner />
              ) : invoiceAllSuccess ? (
                "Erfolgreich gesendet"
              ) : (
                `${invoices.filtered?.length} Rechnung(en) senden`
              )}
            </button>
          </div>
        </div>
        <div className="mx-auto max-w-4xl divide-y divide-gray-900/10">
          <dl className="mt-4 space-y-6 divide-y divide-gray-900/10">
            {invoices.filtered?.map((faq) => (
              <Disclosure as="div" key={faq.email} className="pt-6">
                {({ open }) => (
                  <>
                    <dt>
                      <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
                        <span className="text-base font-semibold leading-7">
                          {faq.fullname} {faq.total}
                        </span>
                        <span className="ml-6 flex h-7 items-center">
                          {open ? (
                            <MinusSmallIcon
                              className="h-6 w-6"
                              aria-hidden="true"
                            />
                          ) : (
                            <PlusSmallIcon
                              className="h-6 w-6"
                              aria-hidden="true"
                            />
                          )}
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className="mt-2">
                      <div className="mt-6 border-b border-gray-200 pb-5 sm:flex sm:items-center sm:justify-between">
                        <p className="text-base leading-7 text-gray-600">
                          {faq.email}
                        </p>
                        <div className="flex">
                          <div className="mt-3 sm:mt-0 sm:ml-4">
                            <button
                              type="button"
                              onClick={() => printInvoice([[faq.email]])}
                              className="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                            >
                              Drucken
                            </button>
                          </div>
                          <div className="mt-3 sm:mt-0 sm:ml-4">
                            <button
                              type="button"
                              onClick={() => downloadInvoice([[faq.email]])}
                              className="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                            >
                              {invoiceDownloading === faq.email ? (
                                <LoadingSpinner />
                              ) : downloadSuccess === faq.email ? (
                                "Erfolgreich geladen"
                              ) : (
                                "Rechnung herunterladen"
                              )}
                            </button>
                          </div>
                          <div className="mt-3 sm:mt-0 sm:ml-4">
                            <button
                              type="button"
                              onClick={() => sendInvoices([[faq.email]])}
                              className="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                            >
                              {invoiceLoading === faq.email ? (
                                <LoadingSpinner />
                              ) : invoiceSuccess === faq.email ? (
                                "Erfolgreich gesendet"
                              ) : (
                                "Rechnung senden"
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
